import { gql } from "@apollo/client";

export const GET_CRAFTMEN_FEED = gql(`
  query UsersHome(
    $where: UserWhereInput
    $orderBy: [UserOrderByWithRelationAndSearchRelevanceInput!]
    $take: Int
    $skip: Int
    $aggregateUserWhere2: UserWhereInput
  ) {
    users(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
      id
      isFavoris
      lastName
      name
      workshopName
      role
      note
      description
      minQuantityOrder
      cuurentUserHaveStory
      country {
        name_en
        name_fr
      }
      Categories {
        name_en
        name_fr
      }
      PhotoAchievements {
        url
      }
      ProfilePhoto {
        url
      } 
      UserStories {
        id
      } 
      NoticeOrders {
        note
        Order {
          Craftman {
            note
          }
        }
      }
    }
    aggregateUser(where: $aggregateUserWhere2) {
      _count {
        _all
      }
    }
  }
`);

export const CRAFTMAN = gql(`
  query Craftman(
    $where: UserWhereUniqueInput!
    $craftmanFavoritesWhere2: FavoritesWhereInput
    $craftmanOrdersWhere2: OrderWhereInput
    $whereNoticeOrderWhereInput: NoticeOrderWhereInput
  ) {
    noticeOrders(where: $whereNoticeOrderWhereInput) {
      id
    }
    user(where: $where) {
      id
      isFavoris
      _count {
        CraftmanOrders(where: $craftmanOrdersWhere2)
        CraftmanFavorites(where: $craftmanFavoritesWhere2)
      }
    }
  }
`);

export const GET_NOTICE = gql(`
  query NoticeOrders(
    $where: NoticeOrderWhereInput
    $orderBy: [NoticeOrderOrderByWithRelationAndSearchRelevanceInput!]
  ) {
    noticeOrders(where: $where, orderBy: $orderBy) {
      id
      note
      description
      createdAt
      Customer {
        id
        name
        lastName
        ProfilePhoto {
          id
          url
        }
      }
    }
  }
`);

export const GET_CRAFTMEN_HIGH_RATED_FEED = gql(`
  query GetUsersSortedByHighNotes($minNote: Float) {
    getUsersSortedByHighNotes(minNote: $minNote) {
      id
      isFavoris
      lastName
      name
      workshopName
      role
      description
      minQuantityOrder
      cuurentUserHaveStory
      country {
        name_en
        name_fr
      }
      Categories {
        name_en
        name_fr
      }
      PhotoAchievements {
        url
      }
      ProfilePhoto {
        url
      } 
      UserStories {
        id
      } 
    }
  }
`);

export const GET_HIGH_RATED_CRAFTMEN = gql(`
  query GetHighRatedCraftmen($take: Int, $skip: Int, $categoryIds: [Int!], $countryIds: [Int!]) {
    getHighRatedCraftmen(take: $take, skip: $skip, categoryIds: $categoryIds, countryIds: $countryIds) {
      id
      isFavoris
      lastName
      name
      workshopName
      role
      note
      description
      minQuantityOrder
      cuurentUserHaveStory
      country {
        name_en
        name_fr
      }
      Categories {
        name_en
        name_fr
      }
      PhotoAchievements {
        url
      }
      ProfilePhoto {
        url
      } 
      UserStories {
        id
      } 
      NoticeOrders {
        note
        Order {
          Craftman {
            note
          }
        }
      }
    }
  }
`);

// query GetCraftmenFeed {
//   craftmenFeed(
//     where: {
//       active: true
//       hasPhotos: true
//       minNote: 3.0
//     }
//     orderBy: {
//       direction: DESC
//     }
//     skip: 0
//     take: 20
//   ) {
//     users {
//       user {
//         id
//         name
//         description
//         ProfilePhoto { url }
//         PhotoAchievements { url }
//       }
//       averageNote
//     }
//     totalCount
//   }
// }
